import React, { useState, useEffect, Suspense } from 'react'
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { toggleMenuAction, selectMenuToggle } from '@/store/slices/appSlice'
import { logout } from '@/store/slices/authSlice';

import { Layout, FloatButton, message } from 'antd'
import routes from '@/routes'
import utils from '@/utils'

import * as echarts from 'echarts/lib/echarts.js'
import avatar from '@/assets/images/user.jpg'
import menu from './menu.js'
import '@/style/layout.css'

import AppHeader from './AppHeader.jsx'
import AppAside from './AppAside.jsx'
import AppFooter from './AppFooter.jsx'

const { Content } = Layout
const { LoadingWithProgress } = utils;

const DefaultLayout = ({Component}) => {
    const [menuList, setMenuList] = useState([])
    const menuToggle = useSelector(selectMenuToggle)
    const dispatch = useDispatch()
    const location = useLocation()
    const navigate = useNavigate()

    const user = JSON.parse(localStorage.getItem('userInfo')) || {}
    const { auth, role } = user

    useEffect(() => {
        const getMenu = menu => {
            if (!role) return menu
            return menu.filter(res => res.auth && res.auth.indexOf(role) !== -1)
        }

        if (!localStorage.getItem('userInfo')) {
            navigate('/admin_login')
        } else {
            setMenuList(getMenu(menu))
        }
    }, [navigate, auth])

    const loginOut = async () => {
        await dispatch(logout()).unwrap();
        // localStorage.clear()
        navigate('/admin_login')
        message.success('登出成功!')
    }

    

    const menuClick = () => {
        dispatch(toggleMenuAction())
    }

    // 路由守卫组件
    // const RouteGuard = ({ component: Component, routeAuth }) => {
    //     if (!auth) {
    //         return  (
    //         <Suspense fallback={<LoadingWithProgress />}>
    //             <Component />
    //         </Suspense>
    //     )
    //     } else if (routeAuth && routeAuth.indexOf(auth) !== -1) {
    //         return  (
    //         <Suspense fallback={<LoadingWithProgress />}>
    //             <Component />
    //         </Suspense>
    //     )
    //     } else {
    //         return <Navigate to="/404" replace />
    //     }
    // }

    // ECharts 自适应逻辑
    useEffect(() => {
        let timer
        if (location.pathname === '/' || location.pathname === '/index') {
            timer = setTimeout(() => {
                ['bar', 'line', 'pie', 'pictorialBar', 'scatter'].forEach(id => {
                    const chart = document.getElementById(id)
                    if (chart) {
                        echarts.init(chart).resize()
                    }
                })
            }, 500)
        }
        return () => timer && clearTimeout(timer)
    }, [location.pathname, menuToggle])

    return (
        <Layout className='app'>
            <FloatButton.BackTop />
            <AppAside menuToggle={menuToggle} menu={menuList} />
            <Layout style={{ marginLeft: menuToggle ? '80px' : '200px', minHeight: '100vh' }}>
                <AppHeader
                    menuToggle={menuToggle}
                    menuClick={menuClick}
                    avatar={avatar}
                    loginOut={loginOut}
                />
                <Content className='content'>
                    
                    <Suspense fallback={<LoadingWithProgress />}>
                        
                                <Suspense fallback={<LoadingWithProgress />}>
                                    <Component />
                                </Suspense>
                          
                        
                       
                        {/* <Routes>
                            {routes.map(item => (
                                <Route
                                    key={item.path}
                                    path={item.path}
                                    element={<RouteGuard component={item.component} routeAuth={item.auth} />}
                                />
                            ))}
                            <Route path="/" element={<Navigate to="/index" replace />} />
                            <Route path="*" element={<Navigate to="/404" replace />} />
                        </Routes> */}
                    </Suspense>
                </Content>
                <AppFooter />
            </Layout>
        </Layout>
    )
}

export default DefaultLayout